/**
 * Where a design page's links lead inside the application.
 *
 * The generated pages link to sibling design files (`Simple-QA-Admin-QA` + device); the application
 * has one address per destination and chooses the device layout itself (`DesignScreen`), so the
 * device part is ignored here.
 */
import {
  ADMIN_COURSES_PATH,
  ADMIN_GROUPS_PATH,
  ADMIN_PATH,
  ADMIN_QA_PATH,
  ADMIN_STUDENTS_PATH,
  COURSES_PATH,
  HOME_PATH,
  PROFILE_PATH,
  QA_PATH,
} from '../../app/paths';
import { setDesignHrefResolver } from '../runtime';

const DESTINATIONS: Readonly<Record<string, string>> = Object.freeze({
  'Simple-QA-Admin-Home': ADMIN_PATH,
  'Simple-QA-Admin-QA': ADMIN_QA_PATH,
  'Simple-QA-Admin-Groups': ADMIN_GROUPS_PATH,
  'Simple-QA-Admin-Students': ADMIN_STUDENTS_PATH,
  'Simple-QA-Courses-Admin': ADMIN_COURSES_PATH,
  'Simple-QA-Course-Studio-Admin': ADMIN_COURSES_PATH,
  'Simple-QA-Student-QA': QA_PATH,
  'Simple-QA-Student-Courses': COURSES_PATH,
  'Simple-QA-Student-Reader': COURSES_PATH,
  'Simple-QA-Student-Profile': PROFILE_PATH,
  'Simple-QA-Access': HOME_PATH,
});

/** The application address of a design file; a link's own query string (`?create=1`) is kept. */
export function productHref(file: string, search = ''): string {
  return (DESTINATIONS[file] ?? HOME_PATH) + search;
}

export function installProductLinks(): void {
  setDesignHrefResolver((file, _device, search) => productHref(file, search));
}
